export default __webpack_public_path__ + "static/media/AdStorm_00.412af73f.png";